<template>
    <div id="agent-list">
        <Modal2
            v-if="assignAgent"
            id="assign-agent"
            :title="$t('message.addRepresentative')"
            :show-footer="false"
            @cancel="assignAgent = false"
        >
            <JoinableAgent :contact="contact" @close="assignAgent = false" />
            <!--            <AssignAgent :assign="true" :show-online-agents="true" @close="assignAgent = false" />-->
        </Modal2>
        <Modal2
            v-if="forwardAgent"
            id="forward-agent"
            :title="$t('message.forwardChat')"
            :show-footer="false"
            @cancel="forwardAgent = false"
        >
            <!--            <AssignAgent :forward="true" :show-online-agents="true" @close="forwardAgent = false" />-->
            <ChatForwardWindow :contact="contact" @close="forwardAgent = false" />
        </Modal2>
        <PreferredAgents
            v-if="preferredAgentModal"
            :modal-enabled="true"
            :visitorId="contact._id"
            @cancel="preferredAgentModal = false"
            v-model="preferredAgents"
        />
        <div class="agent-list-groups">
            <div class="agent-list-group">
                <div class="agent-list-group-head">
                    <div class="agent-list-group-head-title">{{ $t("calendar.agents") }}</div>
                    <div class="agent-list-group-head-actions">
                        <div
                            class="agent-list-group-head-actions-item"
                            v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                            :content="$t('message.forwardRep')"
                            @click="forwardAgent = true"
                        >
                            <div class="material-icons">fast_forward</div>
                        </div>
                        <div
                            class="agent-list-group-head-actions-item"
                            v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                            :content="$t('message.addRepresentative')"
                            @click="assignAgent = true"
                        >
                            <div class="material-icons">add</div>
                        </div>
                    </div>
                </div>
                <div class="agent-list-group-content">
                    <div
                        class="agent-list-group-content-item"
                        v-for="agent of agents"
                        :key="agent._id"
                        v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
                        :content="agent.name"
                        @click="writeAgent(agent)"
                    >
                        <a-popover placement="bottomLeft" trigger="click" overlayClassName="user-options">
                            <template slot="content">
                                <div class="content">
                                    <div
                                        class="d-flex flex-row mt-3 pb-2 user-options-item"
                                        style="border-bottom: 1px solid #f1f4f7"
                                    >
                                        <div class="justify-content-start">
                                            <i class="material-icons">message</i>
                                        </div>
                                        <div class="justify-content-end pl-3 cursorPointer" @click="startDM(agent._id)">
                                            {{ $t("tour.startChat") }}
                                        </div>
                                    </div>
                                    <div
                                        class="d-flex flex-row mt-3 pb-2 user-options-item"
                                        style="border-bottom: 1px solid #f1f4f7"
                                    >
                                        <div class="justify-content-start">
                                            <i class="material-icons">query_stats</i>
                                        </div>
                                        <div class="justify-content-end pl-3 cursorPointer" @click="goToAgentReport">
                                            {{ $t("chatWindow.goToAgentReport") }}
                                        </div>
                                    </div>
                                    <div
                                        class="d-flex flex-row mt-3 pb-2 user-options-item"
                                        style="border-bottom: 1px solid #f1f4f7"
                                    >
                                        <div class="justify-content-start">
                                            <i class="material-icons">info</i>
                                        </div>
                                        <div class="justify-content-end pl-3 cursorPointer" @click="goToUserList">
                                            {{ $t("chatWindow.agentDetail") }}
                                        </div>
                                    </div>
                                    <div class="d-flex flex-row mt-3 user-options-item">
                                        <div class="justify-content-start">
                                            <i class="material-icons">list</i>
                                        </div>
                                        <div class="justify-content-end pl-3 cursorPointer" @click="goToUserList">
                                            {{ $t("chatWindow.agentList") }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div class="material-icons more-icon">more_vert</div>
                        </a-popover>

                        <AgentAvatar :userID="agent._id" :size="40" />
                        <div class="agent-details">
                            <div class="agent-name">{{ agent.name }}</div>
                            <div class="agent-status">
                                <div class="in-chat">
                                    <md-icon class="icon"> sms </md-icon>
                                    <span>{{ $t("message.inChat") }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="agent-list-group">
                <div class="agent-list-group-head">
                    <div class="agent-list-group-head-title">{{ $t("message.prefferedAgents") }}</div>
                    <div class="agent-list-group-head-actions">
                        <SlidingPanel
                            v-if="showSlidingPanel"
                            @close="closeSlidingPanel"
                            @select="handleAgentSelect"
                            :visitorId="contact._id"
                            :preferredAgents="preferredAgents"
                            class="sliding-panel"
                        />
                        <div
                            class="agent-list-group-head-actions-item"
                            v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                            :content="$t('message.addRepresentative')"
                            @click="openSlidingPanel"
                        >
                            <div class="material-icons">edit</div>
                        </div>
                    </div>
                </div>
                <div class="preferred-agent-list-group-content">
                    <div v-if="!getPreferredAgents().length && !showSlidingPanel" class="no-preferred-agents">
                        <NoPreferredAgent @openSelectModal="openSlidingPanel" />
                    </div>
                    <div v-else class="preferred-agent-list-group-list">
                        <div
                            v-if="!showSlidingPanel"
                            class="preferred-agent-list-group-content-item"
                            v-for="agent of getPreferredAgents()"
                            :key="agent._id"
                            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
                            :content="agent.name"
                        >
                            <AgentAvatar :userID="agent._id" :size="40" />
                            <div class="preferred-agent-details">
                                <div class="preferred-agent-name">{{ agent.name }}</div>
                                <div class="preferred-agent-departments">
                                    <span v-for="subject of agent.subjects" color="#8796af" :key="subject._id">
                                        {{ getContentFromLanguageContent(subject) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AgentAvatar from "../../common/AgentAvatar.vue";
import Modal2 from "../../common/Modal2.vue";
import JoinableAgent from "../../../views/Pages/Chat/components/JoinableAgent.vue";
import AssignAgent from "../../AgentList.vue";
import PreferredAgents from "../../PreferredAgents.vue";
import _ from "lodash";
import WatchIcon from "../../svg/WatchIcon.vue";
import OpenChat from "../../svg/OpenChat.vue";
import Block from "../../svg/Block.vue";
import PrivateMessageIcon from "../../svg/PrivateMessageIcon.vue";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";
import NoPreferredAgent from "../components/NoPreferredAgent.vue";
import SlidingPanel from "../components/SlidingPanel.vue";
import { sendSocketMessage } from "../../../utils/socketStream";
import ChatForwardWindow from "../../../views/Pages/Chat/components/ChatForwardWindow.vue";
import moment from "moment";

export default {
    name: "AgentList",
    components: {
        ChatForwardWindow,
        PrivateMessageIcon,
        Block,
        OpenChat,
        WatchIcon,
        PreferredAgents,
        Modal2,
        AssignAgent,
        AgentAvatar,
        NoPreferredAgent,
        SlidingPanel,
        JoinableAgent,
    },
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            users: (state) => {
                const departments = state.subject.subjects.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {});
                return state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = {
                        ...user,
                        subjects: user.subjects.map((subjectId) => departments[subjectId]),
                    };
                    return acc;
                }, {});
            },
        }),
        agents() {
            return this.contact.lastConversation.users.map((userId) => this.users[userId]);
        },
    },
    data: function () {
        return {
            showSlidingPanel: false,
            showPopover: false,
            forwardAgent: false,
            assignAgent: false,
            preferredAgentModal: false,
            preferredAgents: _.cloneDeep(this.contact.preferredAgents),
        };
    },
    methods: {
        ...mapActions({
            updateMultipleKeyContact: "chat/updateMultipleKeyContact",
            updateContactPreferredAgents: "visitor/updatePreferredAgents",
        }),
        closeSlidingPanel() {
            this.showSlidingPanel = false;
        },
        handleAgentSelect(agentList) {
            this.updatePreferredAgents(agentList);
        },
        openSlidingPanel() {
            this.showSlidingPanel = true;
        },
        getPreferredAgents() {
            return (this.preferredAgents || []).map((userId) => this.users[userId]);
        },
        updatePreferredAgents: _.debounce(async function (agentList) {
            await this.updateContactPreferredAgents({
                visitorId: this.contact._id,
                userIds: agentList,
            }).then((data) => {
                this.updateMultipleKeyContact({
                    contactId: this.contact._id,
                    set: {
                        preferredAgents: agentList,
                    },
                });
                sendSocketMessage("visitor profile-updated", {
                    siteId: this.site._id,
                    visitorId: this.contact._id,
                });
                return data;
            });
        }, 700),
        getContentFromLanguageContent(item) {
            return item.languageContent[this.$i18n.locale].name;
        },
        goToUserList() {
            this.$router.push("/chat?tabIndex=representative");
        },
        goToAgentReport() {
            const startDate = moment().subtract(1, "days").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
            const endDate = moment().add(1, "days").endOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
            const userIds = Object.keys(this.users).map(id => id).join(",");
            this.$router.push(`/report-new?report=agent-performance&customDate=custom&startDate=${startDate}&endDate=${endDate}&selectedUsers=${userIds}`);
        },
        startDM(id) {
            this.$router.push("/chat?tabIndex=teamChat");
            setTimeout(() => {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.START_AGENT_CHAT, { userId: id });
            }, 500);
        },
        writeAgent(agent) {
            console.log("agentBurada", { agent });
        },
    },
    watch: {
        contact: {
            deep: true,
            handler(newVal, oldVal) {
                if (!_.isEqual(newVal.preferredAgents, oldVal.preferredAgents)) {
                    this.preferredAgents = _.cloneDeep(newVal.preferredAgents);
                }
            },
        },
        preferredAgents: {
            deep: true,
            handler() {
                if (!_.isEqual(this.preferredAgents, this.contact.preferredAgents)) {
                    this.updatePreferredAgents();
                }
            },
        },
    },
};
</script>
<style lang="scss" scoped>
#agent-list {
    .agent-list-groups {
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 15px;
        white-space: nowrap;
    }

    .agent-list-group {
        display: flex;
        flex-direction: column;
        gap: 5px;
        .agent-list-group-content {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 8px;
        }

        .agent-list-group-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 5px;

            &-title {
                font-size: 16px;
                font-weight: bold;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            &-actions {
                display: flex;
                align-items: center;
                gap: 4px;

                &-item {
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    line-height: 0;
                    cursor: pointer;
                    user-select: none;
                    background: #22272d;
                    border-radius: 4px;

                    .material-icons {
                        font-size: 18px;
                        color: var(--white);
                    }
                }
            }
        }

        &-content {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .agent-list-group-content-item {
                position: relative;
                border-radius: 8px;
                padding: 15px;
                flex: 1 0 auto;
                height: 130px;
                width: 110px;
                display: flex;
                align-items: center;
                gap: 8px;
                flex-direction: column;
                background: #f7f4ff;

                .more-icon {
                    position: absolute;
                    top: 5px;
                    right: 5px;
                    cursor: pointer;
                }

                .agent-details {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;

                    .agent-status {
                        display: flex;
                        gap: 4px;
                        user-select: none;
                        .in-chat {
                            display: flex;
                            gap: 10px;
                            color: #5625cc;
                            .icon {
                                color: inherit;
                            }
                        }
                    }

                    .agent-name {
                        text-align: center;
                        font-weight: bold;
                    }

                    .agent-departments {
                        display: flex;
                        gap: 4px;
                    }
                }
            }
        }
    }
}
.preferred-agent-list-group-content {
    display: flex;

    gap: 15px;
    margin-top: 20px;
    position: relative;
    .preferred-agent-list-group-list {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }
    .preferred-agent-list-group-content-item {
        display: flex;
        gap: 15px;
        .preferred-agent-details {
            display: flex;
            flex-direction: column;
            .preferred-agent-name {
                font-weight: bold;
            }
            .preferred-agent-departments {
                display: flex;
                gap: 4px;
                color: #8796af;
            }
        }
    }
    .no-preferred-agents {
        padding: 20px;
        text-align: center;
        font-size: 14px;
        color: #8796af;
        width: 100% !important;
    }
}

.user-options {
    .ant-popover-inner-content {
        width: max-content;
    }

    .user-options-item {
        &:hover {
            background-color: #f1f4f7;
        }
    }
}

.sliding-panel {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    background: white;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    overflow-y: auto;
}
</style>
